import { concat, get } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = Schema.attributes;

const BeschreibungAbschlussMesse: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title='Beschreibung' description={PLATZHALTER_TEXT} />
			<CreateForm
				formStruc={formStrucSpalte1(application)}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
			/>
		</>
	);
};

export default BeschreibungAbschlussMesse;

const formStrucSpalte1 = (application: any) => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Abschlussbericht_Messefoerderung.schema.attributes.Kurze_Zusammenfassung,
				P.Abschlussbericht_Messefoerderung.schema.attributes.Abschlussbericht_Messefo_0241423470_sseteilnahme_Erreicht_Werden,
				P.Abschlussbericht_Messefoerderung.schema.attributes.Beschreiben_Sie_Kurz_44_0001166083_se_Erreicht_Werden_Konnte_63,
				P.Abschlussbericht_Messefoerderung.schema.attributes.Abschlussbericht_Messefo_0193283847_Internationaler_Ausrichtung,
				P.Abschlussbericht_Messefoerderung.schema.attributes.Abschlussbericht_Messefo_0243766398_An_Dieser_Messe_Teilgenommen,
				P.Abschlussbericht_Messefoerderung.schema.attributes.Abschlussbericht_Messefo_0149259085_n_Und_Ausstellung_Aufmerksam,
				P.Abschlussbericht_Messefoerderung.schema.attributes.Abschlussbericht_Messefo_0052524004_hme_An_Der_Messe_Erleichtert,
				P.Abschlussbericht_Messefoerderung.schema.attributes.Abschlussbericht_Messefo_0061665278_r_An_Dieser_Messe_Teilnehmen,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];

	if (
		get(application, P.Abschlussbericht_Messefoerderung.schema.attributes.Abschlussbericht_Messefo_0061665278_r_An_Dieser_Messe_Teilnehmen.path) ===
		'Nein'
	) {
		struc.push({
			fields: [P.Abschlussbericht_Messefoerderung.schema.attributes.Abschlussbericht_Messefoerderung_Teilnahme_Begruendungwenn_Nein],
			userProps: { direction: 'column', columnToDivide: 1 },
		});
	}
	return struc;
};

export const getFormStrucBeschreibungAbschlussMesse = (application: any) => {
	return concat(formStrucSpalte1(application));
};
